/* eslint-disable @typescript-eslint/prefer-promise-reject-errors */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import Axios, { type InternalAxiosRequestConfig } from 'axios';
function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  const session = localStorage.getItem('sessionInfo');
  const sessionObject = session
    ? (JSON.parse(session) as {
        username: string;
        sessionToken: string;
      })
    : undefined;
  if (sessionObject) {
    config.headers.Authorization = `Bearer ${sessionObject.sessionToken}`;
  }
  config.withCredentials = true;
  return config;
}
/**
 * Scope every request carries, split by the route level that owns it: `game_code`
 * from the `game/:gameCode` loader, `sandbox_code` from the `:sandboxCode` loader
 * and cleared by the game-level dashboard. A request aimed at another scope (a new
 * Sandbox's first language, editing a Sandbox from the game-level list) overrides
 * either key with its own `params` — axios merges them key-by-key, request wins,
 * and an unset slot serialises to nothing.
 */
const scope: { game_code?: string; sandbox_code?: string } = {};

export const setGameScope = (gameCode: string) => {
  scope.game_code = gameCode;
};

/** Called with no argument on game-level routes, which have no sandbox. */
export const setSandboxScope = (sandboxCode?: string) => {
  scope.sandbox_code = sandboxCode;
};

function scopeRequestInterceptor(config: InternalAxiosRequestConfig) {
  config.params = { ...scope, ...(config.params as Record<string, unknown>) };
  return config;
}

export const api = Axios.create({
  baseURL: import.meta.env.VITE_ADMIN_API_URL,
});
api.interceptors.request.use(authRequestInterceptor);
api.interceptors.request.use(scopeRequestInterceptor);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      alert(
        'Your session has expired. You will be redirected to the login screen.',
      );
      if (!currentPath.includes('/login') && currentPath !== '/logout') {
        window.location.href = `/login?from=${encodeURIComponent(currentPath)}`;
      }
    }
    return Promise.reject(error);
  },
);
